import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { showMutationError } from "@/lib/mutation-error";
import { partnerApiService } from "@/services/partner-api.service";
import type { AddMemberInput } from "@/types/partner.types";

export const useAddMember = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: AddMemberInput) => partnerApiService.addMember(input),
		onSuccess: () => {
			toast.success("Member added");
			queryClient.invalidateQueries({ queryKey: ["partner", "members"] });
		},
		onError: (err) => {
			showMutationError(err, "Failed to add member");
		},
	});
};
